import React, { Component } from 'react';
import './App.css';

import HomePage from './pages'


class App extends Component {
    render() {
        return (
            <HomePage />
        );
    }
}

export default App;
